import Cookies from 'js-cookie';
import forceLogoutHandler from './a.users.forceLogoutHandler';
import socketClientManager from '../../sockets/socketClientManager';

import {
  dismissToast,
  logout
} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Log out of session
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestLogout = packet => {
  return {
    type: 'REQUEST_LOGOUT',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveLogoutSuccess = data => ({
  type: 'RECEIVE_LOGOUT_SUCCESS',
  data
})

export const receiveLogoutFail = data => ({
  type: 'RECEIVE_LOGOUT_FAIL',
  data
})

export const tryToLogout = packet => (dispatch, getState) => {

  dispatch(requestLogout(packet));

  let headers = {
    "Content-Type": "application/json"
  }

  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/users/logout-session', {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveLogoutSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveLogoutFail({errors:e, lastSubmit: packet}));
    })
}
